<template>
  <div class="exam">
    <div class="nuv">
      <span>群培训管理&nbsp;&gt;</span>
      <span>{{ groupName }}</span>
    </div>
    <p style="margin-bottom: 20px;">
      <a :href="'/tjkStudy/groupTrain?groupId='+groupId+'&groupName='+groupName" class="top-button"><el-button type="primary" plain>群考核名单</el-button></a>
      <a href="javascript:;" class="top-button"><el-button type="primary">群待岗学员</el-button></a>
      <el-tooltip placement="right" effect="light">
        <div slot="content" class="tip-con">
          <p>群待岗学员发起群考核时，默认全部学员发起考核</p>
        </div>
        <a class="tip-box">？</a>
      </el-tooltip>
    </p>
    <ul class="tab" v-if="!!examiningList">
      <li v-for="(t, key) in examiningList" class="active">
        <a :href="'/tjkStudy/waitWorkExam?id='+t.examineRecordId+'&groupId='+groupId+'&groupName='+groupName" target="_blank">{{ t.codeName }}</a>
      </li>
    </ul>
    <p v-if="!success" class="tj-shift-notice">{{ message }}</p>
    <template v-else>
      <p class="tj-shift-notice" v-if="!list.length">暂无记录！</p>
      <template v-else>
        <el-table ref="multipleTable" border :data="list" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection"></el-table-column>
          <el-table-column prop="realName" label="考核人员"></el-table-column>
          <el-table-column prop="tjkNumber" label="淘金号"></el-table-column>
          <el-table-column label="是否通过">
            <template slot-scope="scope">
              <template v-if="scope.row.passState == 'Passed'">通过</template>
              <template v-if="scope.row.passState == 'Failed'">未通过</template>
              <template v-if="scope.row.passState == 'Abandoned'">标记不参培</template>
              <template v-if="scope.row.passState == 'Retrial'">建议复训</template>
              <template v-if="scope.row.passState == 'AbandonInTrain'">培训老师同意放弃</template>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="综合得分"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
        </el-table>
        <div class="tj-margin-top-xl tj-margin-bottom-xl">
          <el-button @click="toggleSelection">移除待岗学员名单</el-button>
          <el-button type="warning" @click="checkGroup">群考核</el-button>
        </div>
      </template>
    </template>
    <!-- 群考核弹出层 -->
    <Modal ref="check">
      <div class="tj-table tj-fill tj-padding-right-xl">
        <dl>
          <dt class="tj-text-right"><font color="red">*</font> 外呼电话：</dt>
          <dd>
            <el-input placeholder="请输入内容" v-model="check.callOutPhone" clearable></el-input>
          </dd>
        </dl>
        <dl>
          <dt class="tj-text-right" style="width: 200px;"><font color="red">*</font> 平均外呼时长（分钟）：</dt>
          <dd>
            <el-input placeholder="请输入内容" v-model="check.avgDuration" clearable></el-input>
          </dd>
        </dl>
        <dl>
          <dt class="tj-text-right" style="width: 200px;"><font color="red">*</font> 考核代号：</dt>
          <dd>
            <el-input placeholder="请输入内容" v-model="check.codeName" clearable></el-input>
          </dd>
        </dl>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      'success': true,
      'message': '',
      'groupId': this.$route.query.groupId,
      'groupName': this.$route.query.groupName,
      'multipleSelection': [],
      'list': [],
      'check': {
        'callOutPhone': '',
        'avgDuration': '',
        'codeName': ''
      },
      'examiningList': [] //正在考核列表
    }
  },
  mounted: function() {
    this.getList()
  },
  methods: {
    myAlert(msg){
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: action => {
          
        }
      })
    },
    getList() {
      var data = {
        'groupId': this.groupId
      }
      this.$http.post(API_ROOT.college + '/examine/queryReady', data).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.list = result.data.tjkList
          this.examiningList = result.data.examiningList
        }else {
          this.myAlert(result.msg)
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //全选/全不选 移除待岗学员
    toggleSelection() {
      var ids = []
      this.multipleSelection.map((item)=> {
        ids.push(item.examineId)
      })
      if(ids.length == 0) {
        this.myAlert('请先选择淘金客')
        return false
      }
      var data = {
        'examineIds': ids
      }
      this.$http.post(API_ROOT.college + '/examine/removeReady', data).then(response => {
        var result = response.data
        if(result.success) {
          this.$message({
            message: '操作成功',
            type: 'success',
            center: true,
            duration: 1000
          })
          this.getList()
        }else {
          this.myAlert(result.msg)
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //群考核
    checkGroup() {
      var self = this
      self.check.callOutPhone = ''
      self.check.avgDuration = ''
      self.check.codeName = ''

      //发起考核前查询是否存在未结束的考核
      this.$http.post(API_ROOT.college + '/voice/examine/existStartedExamine', {'groupId': self.groupId, 'recordType': 'WaitJob'}, {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}}).then(response => {
        var result = response.data
        if(result.success) {
          if(result.data) {
            self.myAlert('存在未结束的考核，考核结束后才能再次发起群考核！')
          }else {
            //不存在即发起考核
            var ids = []
            self.list.map((item)=> {
              ids.push(item.tjkId)
            })
            this.$refs.check.open({
              title: '群考核',
              width: 800,
              callBack: function (arg) {
                if (arg.type === 'cancel') {
                  arg.close()
                  return
                }
                if(self.check.callOutPhone == '') {
                  self.myAlert('外呼电话不能为空')
                  return false
                }
                if(self.check.avgDuration == '') {
                  self.myAlert('平均外呼时长不能为空')
                  return false
                }
                if(self.check.codeName == '') {
                  self.myAlert('考核代号不能为空')
                  return false
                }
                var reg = /^[0-9]*[1-9][0-9]*$/
                if(!reg.test(self.check.callOutPhone) || !reg.test(self.check.avgDuration)) {
                  self.myAlert('只能填写正整数')
                  return false
                }
                if (arg.pending()) return
                arg.pending(true)

                var data = {
                  'groupId': self.groupId,
                  'callOutPhone': self.check.callOutPhone,
                  'avgDuration': self.check.avgDuration,
                  'codeName': self.check.codeName,
                  'tjkIds': ids
                }
                self.$http.post(API_ROOT.college + '/waitJob/examine/start', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}}).then(response => {
                  arg.pending(false)
                  var result = response.data
                  if(result.success) {
                    self.$message({
                      message: '已添加',
                      type: 'success',
                      center: true,
                      duration: 1000
                    })
                    arg.close()
                    window.location.href = '/tjkStudy/waitWorkExam?id='+result.data+'&groupId='+self.groupId+'&groupName='+self.groupName
                  } else {
                    self.myAlert(result.msg)
                  }
                }, response => {
                  self.myAlert('网络繁忙，请稍后重试！')
                })
              }
            })
          }
        }else {
          self.myAlert(result.msg)
        }
      }, response => {
        self.myAlert('网络繁忙，请稍后重试！')
      })
    }
  }
}
</script>
<style type="less" scoped>
.nuv {
  font-size: 16px;
}
.top-button {
  margin: 10px 15px 20px 0;
  display: inline-block;
}
.tip-box {
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  border: 1px solid #80a9f5;
  text-align: center;
  margin-right: 20px;
}
.tip-con {
  font-size: 14px;
  line-height: 24px;
}
.tab > li {
  float: left;
  padding: 10px;
  margin-bottom: 20px;
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  margin-right: 10px;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
}
.tab > li.active {
  background-color: #ecf5ff;
  border: 1px solid #b3d8ff;
  color: #ffffff;
  cursor: pointer;
}
.tab > li.active:hover {
  background-color: #409EFF;
}
.tab > li.active:hover > a {
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// ./src/page/college/waitWork.vue